import { Cores } from 'src/componentes/styles/cores'
import styled from 'styled-components'

export const CorpoModal = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  width: 900px;
  max-width: 90vw;
  max-height: 85vh;
  overflow-y: auto;
`

export const TituloModal = styled.h5`
  margin-bottom: 16px;
  color: ${Cores.PRIMARIA_1};
`

export const ContainerPDFViewer = styled.div`
  margin: 16px 0;

  iframe {
    display: block;
  }
`

export const AcoesModal = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`
